import { PATH_ANALYTICS, TAB_ANALYTICS } from '../../../constants/paths';

export const RedirectToContentDetails = (row: any, history: any) => {
  history.push(`/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/dashboard?contact_id=${row.contact_id}`);
};

export const disabledLinks = ['/unsub', '/book-a-meeting', '/book-a-demo', '/export_email_html_link'];
